module.exports = __webpack_public_path__ + "static/media/roboto-latin-900_19b7.woff2";